// =========================================================================================================================
// Arabic: ربي يسر ولا تعسر ,و تمم بالخير
// English: O my Lord, make this task easy for me, and do not make it difficult for me and let my affairs end with goodness.
// Code Author: Muhammad Muashir uddin
// =========================================================================================================================

export class Switch extends EventTarget {
  constructor(container, id, on, off, state, changeColor) {
    super();

    this.state = state;
    this.changeColor = changeColor;

    this.el = document.createElement("div");
    this.id = id;
    let txt = document.createElement("div");
    document.body.appendChild(txt);
    txt.classList.add("switch");
    txt.innerText = on;
    let won = txt.offsetWidth;
    txt.innerText = off;
    let woff = txt.offsetWidth;
    this.w = Math.max(won, woff);
    document.body.removeChild(txt);
    Object.assign(this.el.style, {
      position: "relative",
      display: "flex",
      alignItem: "center",
      justifyContent: "space-between",
      padding: "0px 2px 0px 9px",
      width: 2 * this.width + "px",
      height: "20px",
      background: state ? "#58a427" : "#cccccc",
      borderRadius: "3px",
      cursor: "pointer",
      userSelect: "none",
    });

    // Create ON text
    this.textOn = document.createElement("div");
    this.textOn.textContent = on;
    Object.assign(this.textOn.style, {
      width: this.w + 8 + "px",
      // textAlign: "center",
      // padding: "0px 4px",
      paddingTop: "2px",
      // fontFamily: "Manrope",
      fontSize: "0.85em",
      color: "white",
      pointerEvents: "none",
    });

    // Create OFF text
    this.textOff = document.createElement("div");
    this.textOff.textContent = off;
    Object.assign(this.textOff.style, {
      width: this.w + 8 + "px",
      textAlign: "center",
      paddingTop: "2px",
      // padding: "0px 4px",
      // fontFamily: "Manrope",
      fontSize: "0.85em",
      marginLeft: "4px",
      color: "white",
      pointerEvents: "none",
    });

    // Create moving box
    this.box = document.createElement("div");
    Object.assign(this.box.style, {
      position: "absolute",
      top: "2px",
      width: this.w + 12 + "px",
      height: "16px",
      background: "white",
      borderRadius: "3px",
      transition: "left 0.2s ease",
    });
    this.box.style.left = "2px";
    if (state) {
      this.box.style.left = this.w + 17 + "px";
    }
    this.el.appendChild(this.textOn);
    this.el.appendChild(this.textOff);
    this.el.appendChild(this.box);

    container.appendChild(this.el);

    this.el.addEventListener("click", () => this.toggle());
  }

  toggle() {
    this.state = !this.state;
    if (this.state) {
      if (this.changeColor) {
        this.el.style.background = "#4caf50";
      }
      this.box.style.left = this.w + 17 + "px";
    } else {
      if (this.changeColor) {
        this.el.style.background = "#cccccc";
      }
      this.box.style.left = "2px";
    }

    // Dispatch custom event with current state
    this.dispatchEvent(
      new CustomEvent("SWITCH_CHANGE", {
        detail: { id: this.id, state: this.state },
      }),
    );
  }
  setState(newState) {
    this.state = newState;

    if (this.state) {
      this.el.style.background = "#4caf50";
      this.box.style.left = "42px";
    } else {
      this.el.style.background = "#ccc";
      this.box.style.left = "1px";
    }
  }
}
